import { useTranslation } from 'react-i18next';

export const Hero = () => {
  const { t } = useTranslation();
  const badges = [
    { label: t('hero.badgeLimited'), bg: 'bg-candy-yellow' },
    { label: t('hero.badgeVegan'), bg: 'bg-candy-cyan' },
    { label: t('hero.badgeCouples'), bg: 'bg-candy-pink' },
  ];

  return (
    <section id="top" className="mx-auto max-w-content px-4 pt-5 text-center md:px-6 md:pt-8" data-testid="hero-section">
      <ul className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 sm:mx-0 sm:inline-flex sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0">
        {badges.map((b) => (
          <li key={b.label} className={`flex-none whitespace-nowrap rounded-full px-3.5 py-[7px] text-[13px] font-bold ${b.bg}`}>
            {b.label}
          </li>
        ))}
      </ul>
      <h1
        data-testid="hero-headline"
        className="mx-auto mt-4 max-w-[1100px] font-heading text-[clamp(48px,7.4vw,112px)] font-extrabold leading-[0.92] tracking-[-0.045em] md:mt-6"
      >
        {t('hero.titleStart')} <span className="text-accent">{t('hero.titleAccent')}</span>
      </h1>
    </section>
  );
};
